import { useState, useEffect } from 'react';
import { notNullOrEmpty } from './../../utils/validators';

export const FloatingTextAreaInput = ({ label, text, updateCallback, className, required, validatorFn, readOnly, onClick }) => {

    const isValidLength = () => readOnly || (!!required ? notNullOrEmpty(text) : true);
    const isValidFormat = () => readOnly || (isValidLength() && validatorFn(text));

    const [valueChanged, setValueChanged] = useState(notNullOrEmpty(text));

    useEffect(() => {
        setValueChanged(value => value || notNullOrEmpty(text));
    }, [text]);

    const validInput = () => {

        if (!valueChanged || readOnly) {
            return true;
        }

        let valid = true;
        valid &&= isValidFormat();
        valid &&= valueChanged && !!validatorFn ? validatorFn(text) : true;
        return valid;
    };

    const style = validInput() ? {} : {
        borderColor: "red",
        color: "red"
    };

    const boxShadow = {
        boxShadow: '1px 2px 9px rgba(244, 170, 185, 1)'
    }

    return (
        <>
            <div className={`form-floating mb-3 mb-md-0 ${className}`}>
                <textarea onClick={() => { return onClick ? onClick() : () => { }}} rows={4} readOnly={readOnly} required={required} style={validInput() ? style : { ...style, ...boxShadow }} className={`h-100 form-control fs-15px ${validInput() ? 'text-black-900' : 'text-red'} `} id="text" placeholder="Enter Value" value={text} onChange={e => updateCallback(e.target.value)} />
                <label htmlFor="text" className="d-flex fs-13px text-black">{label ?? "Text Value"}</label>
            </div>
            {valueChanged && <>
                <div className='mt-5px' style={isValidLength() ? { display: "none" } : style} >Value is required</div>
                <div className='mt-5px' style={isValidFormat() ? { display: "none" } : style} >Value format is invalid</div>
            </>}
        </>
    );
};